import instObj from '@/backend/axios-instances'

const resource = "/proposal/"
const instance = instObj.baseInstance

export default {
  get(projectId, proposalId) {
    return instance.get(`project/${projectId}${resource}${proposalId}`);
  },
  put(projectId, proposalId, data) {
    return instance.put(`project/${projectId}${resource}${proposalId}`, data);
  },
  delete(projectId, proposalId) {
    return instance.delete(`project/${projectId}${resource}${proposalId}`);
  }
}
